export default __webpack_public_path__ + "static/media/Banner_image_Kaapse.7d26dea4.jpg";